
const IMGS = [
    './static/image/aj/A0000.png',
    './static/image/aj/A0001.png',
    './static/image/aj/A0002.png',
    './static/image/aj/A0003.png',
    './static/image/aj/A0004.png',
    './static/image/aj/A0005.png',
    './static/image/aj/A0006.png',
    './static/image/aj/A0007.png',
    './static/image/aj/A0008.png',
    './static/image/aj/A0009.png',
    './static/image/aj/A0010.png',
    './static/image/aj/A0011.png',
    './static/image/aj/A0012.png',
    './static/image/aj/A0013.png',
    './static/image/aj/A0014.png',
    './static/image/aj/A0015.png',
    './static/image/aj/A0016.png',
    './static/image/aj/A0017.png',
    './static/image/aj/A0018.png',
    './static/image/aj/A0019.png',
    './static/image/aj/A0020.png',
    './static/image/aj/A0021.png',
    './static/image/aj/A0022.png',
    './static/image/aj/A0023.png',
    './static/image/aj/A0024.png',
    './static/image/aj/A0025.png',
    './static/image/aj/A0026.png',
    './static/image/aj/A0027.png',
    './static/image/aj/A0028.png',
    './static/image/aj/A0029.png',
    './static/image/aj/A0030.png',
    './static/image/aj/A0031.png',
    './static/image/aj/A0032.png',
    './static/image/aj/A0033.png',
    './static/image/aj/A0034.png',
    './static/image/aj/A0035.png',
    './static/image/aj/A0036.png',
    './static/image/aj/A0037.png',
    './static/image/aj/A0038.png',
    './static/image/aj/A0039.png',
    './static/image/aj/A0040.png',
    './static/image/aj/A0041.png',
    './static/image/aj/A0042.png',
    './static/image/aj/A0043.png',
    './static/image/aj/A0044.png',
    './static/image/aj/A0045.png',
    './static/image/aj/A0046.png',
    './static/image/aj/A0047.png',
    './static/image/aj/A0048.png',
    './static/image/aj/A0049.png',
    './static/image/heart/1.png',
    './static/image/heart/2.png',
    './static/image/heart/3.png',
    './static/image/heart/4.png',
    './static/image/heart/5.png',
    './static/image/heart/6.png',
    './static/image/heart/7.png',
    './static/image/heart/8.png',
    './static/image/swoosh/swoosh(2)0000.png',
    './static/image/swoosh/swoosh(2)0001.png',
    './static/image/swoosh/swoosh(2)0002.png',
    './static/image/swoosh/swoosh(2)0003.png',
    './static/image/swoosh/swoosh(2)0004.png',
    './static/image/swoosh/swoosh(2)0005.png',
    './static/image/swoosh/swoosh(2)0006.png',
    './static/image/swoosh/swoosh(2)0007.png',
    './static/image/swoosh/swoosh(2)0008.png',
    './static/image/swoosh/swoosh(2)0009.png',
    './static/image/swoosh/swoosh(2)0010.png',
    './static/image/swoosh/swoosh(2)0011.png',
    './static/image/swoosh/swoosh(2)0012.png',
    './static/image/swoosh/swoosh(2)0013.png',
    './static/image/swoosh/swoosh(2)0014.png',
    './static/image/swoosh/swoosh(2)0015.png',
    './static/image/swoosh/swoosh(2)0016.png',
    './static/image/swoosh/swoosh(2)0017.png',
    './static/image/swoosh/swoosh(2)0018.png',
    './static/image/swoosh/swoosh(2)0019.png',
    './static/image/swoosh/swoosh(2)0020.png',
    './static/image/swoosh/swoosh(2)0021.png',
    './static/image/swoosh/swoosh(2)0022.png',
    './static/image/swoosh/swoosh(2)0023.png',
    './static/image/swoosh/swoosh(2)0024.png',
    './static/image/swoosh/swoosh(2)0025.png',
    './static/image/swoosh/swoosh(2)0026.png',
    './static/image/swoosh/swoosh(2)0027.png',
    './static/image/swoosh/swoosh(2)0028.png',
    './static/image/swoosh/swoosh(2)0029.png',
    './static/image/swoosh/swoosh(2)0030.png',
    './static/image/swoosh/swoosh(2)0031.png',
    './static/image/swoosh/swoosh(2)0032.png',
    './static/image/swoosh/swoosh(2)0033.png',
    './static/image/swoosh/swoosh(2)0034.png',
    './static/image/swoosh/swoosh(2)0035.png',
    './static/image/swoosh/swoosh(2)0036.png',
    './static/image/swoosh/swoosh(2)0037.png',
    './static/image/swoosh/swoosh(2)0038.png',
    './static/image/swoosh/swoosh(2)0039.png',
    './static/image/swoosh/swoosh(2)0040.png',
    './static/image/swoosh/swoosh(2)0041.png',
    './static/image/swoosh/swoosh(2)0042.png',
    './static/image/swoosh/swoosh(2)0043.png',
    './static/image/swoosh/swoosh(2)0044.png',
    './static/image/swoosh/swoosh(2)0045.png',
    './static/image/swoosh/swoosh(2)0046.png',
    './static/image/swoosh/swoosh(2)0047.png',
    './static/image/swoosh/swoosh(2)0048.png',
    './static/image/swoosh/swoosh(2)0049.png',
    './static/image/swoosh/swoosh(2)0050.png',
    './static/image/goddess2/胜利女神0000.png',
    './static/image/goddess2/胜利女神0001.png',
    './static/image/goddess2/胜利女神0002.png',
    './static/image/goddess2/胜利女神0003.png',
    './static/image/goddess2/胜利女神0004.png',
    './static/image/goddess2/胜利女神0005.png',
    './static/image/goddess2/胜利女神0006.png',
    './static/image/goddess2/胜利女神0007.png',
    './static/image/goddess2/胜利女神0008.png',
    './static/image/goddess2/胜利女神0009.png',
    './static/image/goddess2/胜利女神0010.png',
    './static/image/goddess2/胜利女神0011.png',
    './static/image/goddess2/胜利女神0012.png',
    './static/image/goddess2/胜利女神0013.png',
    './static/image/goddess2/胜利女神0014.png',
    './static/image/goddess2/胜利女神0015.png',
    './static/image/goddess2/胜利女神0016.png',
    './static/image/goddess2/胜利女神0017.png',
    './static/image/goddess2/胜利女神0018.png',
    './static/image/goddess2/胜利女神0019.png',
    './static/image/goddess2/胜利女神0020.png',
    './static/image/goddess2/胜利女神0021.png',
    './static/image/goddess2/胜利女神0022.png',
    './static/image/goddess2/胜利女神0023.png',
    './static/image/goddess2/胜利女神0024.png',
    './static/image/goddess2/胜利女神0025.png',
    './static/image/goddess2/胜利女神0026.png',
    './static/image/goddess2/胜利女神0027.png',
    './static/image/goddess2/胜利女神0028.png',
    './static/image/goddess2/胜利女神0029.png',
    './static/image/goddess2/胜利女神0030.png',
    './static/image/goddess2/胜利女神0031.png',
    './static/image/goddess2/胜利女神0032.png',
    './static/image/goddess2/胜利女神0033.png',
    './static/image/goddess2/胜利女神0034.png',
    './static/image/goddess2/胜利女神0035.png',
    './static/image/goddess2/胜利女神0036.png',
    './static/image/goddess2/胜利女神0037.png',
    './static/image/goddess2/胜利女神0038.png',
    './static/image/goddess2/胜利女神0039.png',
    './static/image/goddess2/胜利女神0040.png',
    './static/image/goddess2/胜利女神0041.png',
    './static/image/goddess2/胜利女神0042.png',
    './static/image/goddess2/胜利女神0043.png',
    './static/image/goddess2/胜利女神0044.png',
    './static/image/goddess2/胜利女神0045.png',
    './static/image/goddess2/胜利女神0046.png',
    './static/image/goddess2/胜利女神0047.png',
    './static/image/goddess2/胜利女神0048.png',
    './static/image/goddess2/胜利女神0049.png',
    './static/image/goddess2/胜利女神0050.png',
    './static/image/goddess2/胜利女神0051.png',
    './static/image/goddess2/胜利女神0052.png',
    './static/image/goddess2/胜利女神0053.png',
    './static/image/goddess2/胜利女神0054.png',
    './static/image/goddess2/胜利女神0055.png',
    './static/image/goddess2/胜利女神0056.png',
    './static/image/666/6-10000.png',
    './static/image/666/6-10001.png',
    './static/image/666/6-10002.png',
    './static/image/666/6-10003.png',
    './static/image/666/6-10004.png',
    './static/image/666/6-10005.png',
    './static/image/666/6-10006.png',
    './static/image/666/6-10007.png',
    './static/image/666/6-10008.png',
    './static/image/666/6-10009.png',
    './static/image/666/6-10010.png',
    './static/image/666/6-10011.png',
    './static/image/666/6-10012.png',
    './static/image/666/6-10013.png',
    './static/image/666/6-10014.png',
    './static/image/666/6-10015.png',
    './static/image/666/6-10016.png',
    './static/image/666/6-10017.png',
    './static/image/666/6-10018.png',
    './static/image/666/6-10019.png',
    './static/image/666/6-10020.png',
    './static/image/666/6-10021.png',
    './static/image/666/6-10022.png',
    './static/image/666/6-10023.png',
    './static/image/666/6-10024.png',
    './static/image/666/6-10025.png',
    './static/image/666/6-10026.png',
    './static/image/666/6-10027.png',
    './static/image/666/6-10028.png',
    './static/image/666/6-10029.png',
    './static/image/666/6-10030.png',
    './static/image/666/6-10031.png',
    './static/image/666/6-10032.png',
    './static/image/666/6-10033.png',
    './static/image/666/6-10034.png',
    './static/image/666/6-10035.png',
    './static/image/666/6-10036.png',
    './static/image/666/6-10037.png',
    './static/image/666/6-10038.png',
    './static/image/666/6-10039.png',
    './static/image/666/6-10040.png',
    './static/image/666/6-10041.png',
    './static/image/666/6-10042.png',
    './static/image/666/6-10043.png',
    './static/image/666/6-10044.png',
    './static/image/666/6-10045.png',
    './static/image/666/6-10046.png',
    './static/image/666/6-10047.png',
    './static/image/666/6-10048.png',
    './static/image/666/6-10049.png',
    './static/image/666/6-10050.png',
    './static/image/666/6-10051.png',
    './static/image/666/6-10052.png',
    './static/image/666/6-10053.png',
    './static/image/666/6-10054.png',
    './static/image/666/6-10055.png',
    './static/image/666/6-10056.png',
    './static/image/666/6-10057.png',
    './static/image/666/6-10058.png',
    './static/image/666/6-10059.png',
    './static/image/666/6-10060.png',
    './static/image/666/6-10061.png',
    './static/image/666/6-10062.png',
    './static/image/666/6-10063.png',
    './static/image/666/6-10064.png',
    './static/image/666/6-10065.png',
    './static/image/666/6-10066.png',
    './static/image/666/6-10067.png',
    './static/image/666/6-10068.png',
    './static/image/666/6-10069.png',
    './static/image/666/6-10070.png',
    './static/image/666/6-10071.png',
    './static/image/666/6-10072.png',
    './static/image/666/6-10073.png',
    './static/image/rocket/新火箭(1)0000.png',
    './static/image/rocket/新火箭(1)0001.png',
    './static/image/rocket/新火箭(1)0002.png',
    './static/image/rocket/新火箭(1)0003.png',
    './static/image/rocket/新火箭(1)0004.png',
    './static/image/rocket/新火箭(1)0005.png',
    './static/image/rocket/新火箭(1)0006.png',
    './static/image/rocket/新火箭(1)0007.png',
    './static/image/rocket/新火箭(1)0008.png',
    './static/image/rocket/新火箭(1)0009.png',
    './static/image/rocket/新火箭(1)0010.png',
    './static/image/rocket/新火箭(1)0011.png',
    './static/image/rocket/新火箭(1)0012.png',
    './static/image/rocket/新火箭(1)0013.png',
    './static/image/rocket/新火箭(1)0014.png',
    './static/image/rocket/新火箭(1)0015.png',
    './static/image/rocket/新火箭(1)0016.png',
    './static/image/rocket/新火箭(1)0017.png',
    './static/image/rocket/新火箭(1)0018.png',
    './static/image/rocket/新火箭(1)0019.png',
    './static/image/rocket/新火箭(1)0020.png',
    './static/image/rocket/新火箭(1)0021.png',
    './static/image/rocket/新火箭(1)0022.png',
    './static/image/rocket/新火箭(1)0023.png',
    './static/image/rocket/新火箭(1)0024.png',
    './static/image/rocket/新火箭(1)0025.png',
]

export default IMGS


// WEBPACK FOOTER //
// ./src/utils/preLoadImg.js